import React from 'react';
import { Wifi, WifiOff, AlertCircle } from 'lucide-react';
import { usePWA } from '../../hooks/usePWA';

const ConnectionStatus = () => {
  const { isOnline } = usePWA();

  if (isOnline) {
    return null; // Не показываем когда онлайн
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-red-600 text-white py-2 px-4 z-50">
      <div className="flex items-center justify-center space-x-2">
        <WifiOff className="h-4 w-4" />
        <span className="text-sm font-medium">
          Нет подключения к интернету
        </span>
        <AlertCircle className="h-4 w-4" />
      </div>
    </div>
  );
};

export default ConnectionStatus;
